import { LUDUM_CALENDAR_VIEWS } from '@/constants';
import { DATE_FORMAT_API } from '@/constants/dateTimeFormats';
import moment from 'moment';
import get from 'get-object-path';

function getObjectForFilter(item) {
    return {
        id: item.id,
        name: item.name,
        selected: true
    };
}

export const calendar = {
    state: {
        currentDate: moment(),
        calendarView: LUDUM_CALENDAR_VIEWS.MONTH,
        agendaItems: [],
        sessionsToAssign: [],
        sessionTypes: [],
        weeklySummaryMonth: '',
        intensities: [],
        focuses: [],

        filter: {
            event_tag_ids: [],
            athlete_ids: [],
            from_date: moment(),
            to_date: moment(),
            display: 'my-sessions',
            session_types: [],
            intensities: [],
            focuses: []
        },

        selectAllAgendaSessions: false
    },

    getters: {
        agendaItems(state) {
            return _.sortBy(state.agendaItems, 'start_date');
        },

        calendarView(state) {
            return state.calendarView;
        },

        currentDate(state) {
            return state.currentDate;
        },

        calendarFilters(state) {
            const filters = {};

            const selectedIntensities = _.map(_.filter(state.filter.intensities, ['selected', true]), 'id');
            if (selectedIntensities.length < state.intensities.length) {
                filters.intensities = selectedIntensities;
            }

            const selectedSessionTypes = _.map(_.filter(state.filter.session_types, ['selected', true]), 'id');
            if (selectedSessionTypes.length < state.sessionTypes.length) {
                filters.session_types = selectedSessionTypes;
            }

            const selectedFocuses = _.map(_.filter(state.filter.focuses, ['selected', true]), 'id');
            if (selectedFocuses.length < state.focuses.length) {
                filters.focuses = selectedFocuses;
            }

            filters.display = state.filter.display;

            if (state.filter.athlete_ids.length) {
                filters.athlete_ids = state.filter.athlete_ids;
            }

            if (state.filter.event_tag_ids.length) {
                filters.event_tag_ids = state.filter.event_tag_ids;
            }

            return filters;
        }
    },

    mutations: {
        saveWeeklySummaryMonth(state, month) {
            state.weeklySummaryMonth = month;
        },

        saveCurrentDate(state, date) {
            state.currentDate = date;
        },

        saveCurrentView(state, view) {
            state.calendarView = view;
        },

        agendaItems(state, data) {
            state.agendaItems = [];
            data.forEach(item => {
                if (!state.agendaItems.some(({ id }) => id === item.id)) {
                    state.agendaItems.push(Object.freeze(item));
                }
            });
        },

        intensities(state, data) {
            state.intensities = data;
            state.filter.intensities = data.map(getObjectForFilter);
        },

        sessionTypes(state, data) {
            state.sessionTypes = data;
            state.filter.session_types = data.map(getObjectForFilter);
        },

        calendarFocuses(state, data) {
            state.focuses = data;
            state.filter.focuses = data.map(getObjectForFilter);
        },

        assignSession(state, data) {
            if (!_.find(state.sessionsToAssign, { id: data.id })) {
                state.sessionsToAssign.push(data);
            }
        },

        unassignSession(state, data) {
            state.sessionsToAssign = _.filter(state.sessionsToAssign, n => n.id !== data.id);
        },

        resetSessionsToAssign(state) {
            state.sessionsToAssign = [];
        },

        clearFilters(state) {
            state.filter.event_tag_ids = [];
            state.filter.athlete_ids = [];
            state.filter.from_date = moment();
            state.filter.to_date = moment();
            state.filter.display = 'my-sessions';

            _.each(state.filter.session_types, item => {
                item.selected = true;
            });

            _.each(state.filter.intensities, item => {
                item.selected = true;
            });

            _.each(state.filter.focuses, item => {
                item.selected = true;
            });
        }
    },

    actions: {
        getAgenda(context, payload) {
            return context
                .dispatch('post', {
                    url: api + 'agenda?fields=id|session_id|start_date|end_date|sport|name|all_day_event',
                    data: _.assign(_.clone(context.getters.calendarFilters), {
                        start_date: moment(payload.start_date).format(DATE_FORMAT_API),
                        end_date: moment(payload.end_date).format(DATE_FORMAT_API),
                        club_id: payload.club_id,
                        include:
                            'attendance,' +
                            'intensities:fields(id|name),' +
                            'statistics:fields(attending|has_results|has_gps_data|has_hr_data|crews),' +
                            'user_actions'
                    })
                })
                .then(response => {
                    context.commit('agendaItems', response.data.data);
                });
        },

        scrollToToday(context) {
            const today = moment().format('X');
            const items = _.sortBy(context.getters.agendaItems, [
                function(o) {
                    return Math.abs(moment(o.start_date).format('X') - today);
                }
            ]);

            if (items.length) {
                const el = document.querySelector('[data-date="' + moment(items[0].start_date).format('X') + '"]');
                window.scroll(0, el.offsetTop - 220);
            }
        },

        selectAllAgendaSessions(context) {
            const editableSessions = context.getters.agendaItems.filter(item => get(item, 'user_actions.data.edit'));

            _.each(editableSessions, item => {
                if (!context.state.selectAllAgendaSessions) {
                    context.commit('assignSession', item);
                } else {
                    context.commit('unassignSession', item);
                }
            });

            context.state.selectAllAgendaSessions = !context.state.selectAllAgendaSessions;
        }
    }
};
